<template>
    <section class="c-api-hero">
        <div
            v-if="content"
            class="c-api-hero--loaded"
        >
            <div class="c-api-hero__content">
                <div class="hero-content">
                    <div
                        v-if="content.title"
                        class="hero-content__title"
                    >
                        <h1 v-html="textReplacer(content.title, 'hero-title-primary')" />
                    </div>
                    <div
                        v-if="content.synopsis"
                        class="hero-content__description"
                    >
                        <p>
                            {{ content.synopsis }}
                        </p>
                    </div>
                    <div class="hero-content__action">
                        <y-button
                            :tag="isLink(content.custom['button-link']) ? 'a' : 'router-link'"
                            :href="content.custom['button-link']"
                            :to="content.custom['button-link']"
                            :content="content.custom['button-title']"
                            color="primary"
                            size="medium"
                            flat
                            :no-padding="true"
                        />
                    </div>
                </div>
            </div>
            <div class="c-api-hero__image-container">
                <img
                    :src="imgSrc(content.image)"
                    :alt="content.title"
                    class="mvp-hero-img"
                >
            </div>
        </div>
    </section>
</template>

<script >
    import { textReplacer, isLink } from '@/helpers/helpers';

    export default {
        name: 'VideoAudioHero',

        props: {
            content: {
                type   : Object,
                require: true,
            },
        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            textReplacer,
            isLink,
        },
    };

</script>

<style lang="scss" src="./hero.scss"/>
